<!-- create j i s h e n g h u a -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form-model layout="inline" @keyup.enter.native="loadData()">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-model-item label="发货编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入发货编号" v-model="queryParam.number"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="出库编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入出库编号" v-model="queryParam.linkHeadNumber"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="收货单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入收货单位" v-model="queryParam.organName"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="选择单据状态" v-model="queryParam.status">
                    <a-select-option value="0">待审核</a-select-option>
                    <a-select-option value="1">待发货</a-select-option>
                    <a-select-option value="2">已发货</a-select-option>
                    <a-select-option value="3">已签收</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-model-item label="送货地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入送货地址" v-model="queryParam.address"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="发货日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width:100%"
                    v-model="queryParam.createTimeRange"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onDateChange"
                    @ok="onDateOk"
                  />
                </a-form-model-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="6" :sm="24">
                  <a-button type="primary" @click="searchQuery()">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset()">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form-model>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator"  style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="add" type="primary" icon="plus">新增</a-button>
<!--          <a-dropdown v-if="false">-->
<!--            <a-menu slot="overlay">-->
<!--              <a-menu-item key="1" v-if="btnEnableList.indexOf(1)>-1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
<!--              &lt;!&ndash;              <a-menu-item key="2" v-if="btnEnableList.indexOf(2)>-1" @click="batchSetStatus(1)"><a-icon type="check"/>审核</a-menu-item>&ndash;&gt;-->
<!--              &lt;!&ndash;              <a-menu-item key="3" v-if="btnEnableList.indexOf(7)>-1" @click="batchSetStatus(0)"><a-icon type="stop"/>反审核</a-menu-item>&ndash;&gt;-->
<!--            </a-menu>-->
<!--            <a-button>-->
<!--              批量操作 <a-icon type="down" />-->
<!--            </a-button>-->
<!--          </a-dropdown>-->
        </div>
        <!-- table区域-begin -->
        <div class="tableContainer" ref="tableBox">
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="view(record)">查看</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" @click="edit(record)">编辑</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" type="vertical" />
              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" title="确定审核通过吗?" @confirm="() => audit(record)">
                <a >审核</a>
              </a-popconfirm>
              <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" type="vertical" />
              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1 && record.status === '0'" title="确定删除吗?" @confirm="() => remove(record)">
                <a>删除</a>
              </a-popconfirm>
              <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status === '1'" type="vertical" />
              <a  v-if="btnEnableList.indexOf(1)>-1 && record.status === '1'" @click="next(record,'2')">发货</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status === '2'" type="vertical" />
              <a  v-if="btnEnableList.indexOf(1)>-1 && record.status === '2'" @click="next(record,'3')">签收</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status === '2' || record.status === '3'" type="vertical" />
              <a  v-if="btnEnableList.indexOf(1)>-1 && (record.status === '2' ||  record.status === '3') " @click="updateLogistics(record)">物流更新</a>
               <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a  v-if="btnEnableList.indexOf(1)>-1" @click="print(record)">打印送货单</a>
            </span>
            <template slot="customRenderStatus" slot-scope="status">
              <a-tag v-if="status == '0'" color="red">待审核</a-tag>
              <a-tag v-if="status == '1'" color="green">待发货</a-tag>
              <a-tag v-if="status == '2'" color="blue">已发货</a-tag>
              <a-tag v-if="status == '3'" color="cyan">已签收</a-tag>
            </template>
          </a-table>
        </div>
        <logistics-modal ref="logisticsRef" @reload="loadData()"/>
        <logistics-handler-modal ref="logisticsHandlerRef" @reload="loadData()"/>
        <logistics-info-modal ref="logisticsInfoRef" @reload="loadData()"/>
        <logistics-detail-modal ref="logisticsDetailRef" />
        <logistics-detail-print-modal ref="logisticsPrintRef" />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import JDate from '@comp/jeecg/JDate'
import LogisticsModal from '@views/bill/modules/LogisticsModal'
import LogisticsHandlerModal from '@views/bill/dialog/LogisticsHandlerModal'
import LogisticsInfoModal from '@views/bill/dialog/LogisticsInfoModal'
import LogisticsDetailModal from '@views/bill/dialog/LogisticsDetailModal'
import LogisticsDetailPrintModal from '@views/bill/dialog/LogisticsDetailPrintModal'
import { Logistics } from '@api/logistics'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
export default {
  name: "LogisticsListz",
  mixins:[JeecgListMixin],
  components:{
    LogisticsModal,
    JDate,
    LogisticsHandlerModal,
    LogisticsInfoModal,
    LogisticsDetailModal,
    LogisticsDetailPrintModal


  },
  data () {
    return {
      // 表头
      columns:[
        { title: '发货编号', dataIndex: 'number',width:120, ellipsis:true},
        { title: '收货单位', dataIndex: 'organName',width:120, ellipsis:true},
        { title: '送货地址', dataIndex: 'address',width:120, ellipsis:true},
        { title: '联系电话', dataIndex: 'phoneNum',width:145},
        { title: '承运人', dataIndex: 'carrier',width:145},
        { title: '发货时间', dataIndex: 'deliveryTime',width:145},
        { title: '签收时间', dataIndex: 'signTime',width:145},
        { title: '状态', dataIndex: 'status', width: 80, align: "center",
          scopedSlots: { customRender: 'customRenderStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center", width: 180,
          scopedSlots: { customRender: 'action' },
        }
      ],
      labelCol:{ span: 5 },
      wrapperCol:{ span: 18, offset: 1 },
      cardStyle:'',
      url: {
        list: "/logistics/list",
      }
    }
  },
  methods:{
    edit(record){
      this.$refs.logisticsRef.show(record)
    },
    next(record, status){
      let values = JSON.parse(JSON.stringify(record))
      values.status = status
      this.$refs.logisticsHandlerRef.show(values)
    },
    async audit(record){
      record.status = '1'
      await Logistics.save(record)
      this.$message.success('审核成功')
      await this.loadData()
    },
    async remove({id}){
      await Logistics.delete(id)
      this.$message.success('删除成功')
      await this.loadData()
    },
    updateLogistics(record){
      this.$refs.logisticsInfoRef.show(record)
    },
    view(record){
      this.$refs.logisticsDetailRef.show(record)
    },
    add(){
      this.$refs.logisticsRef.show()
    },
    print(record){
      this.$refs.logisticsPrintRef.show(record)
    },
    batchDel(){

    },
    onDateChange(dateString){
      this.queryParam.startTime= moment(dateString[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime= moment(dateString[1]).format('YYYY-MM-DD HH:mm:ss');
    },
    onDateOk(value){
      console.log(value)
    }
  }

}

</script>
<style scoped>
@import '~@assets/less/common.less'
</style>